import React from 'react';
import { renderToStaticMarkup } from 'react-dom/server';

const getTitle = (
	children: React.ReactNode,
	defaultTitle?: string
): string | undefined => {
	const childrenTextContent = getChildrenTextContent(children);

	return childrenTextContent ?? defaultTitle;
};

const getAriaLabel = (
	children: React.ReactNode,
	prefix?: string,
	defaultLabel?: string
): string | undefined => {
	const childrenTextContent = getChildrenTextContent(children);
	const content = childrenTextContent ?? defaultLabel ?? '';

	if (prefix) {
		return `${prefix}: ${content}`;
	}

	return content;
};

const getChildrenTextContent = (
	children: React.ReactNode
): string | undefined => {
	if (Array.isArray(children)) {
		const firstTextChild = children.find(
			(c) => typeof c === 'string' || typeof c === 'number'
		);
		return firstTextChild as string;
	} else if (typeof children === 'string' || typeof children === 'number') {
		return children.toString();
	}

	if (children && React.isValidElement(children)) {
		const markup = renderToStaticMarkup(children);
		const el = document.createElement('div');
		el.innerHTML = markup;
		const text = el.textContent;
		el.remove();
		return text ?? undefined;
	}

	return undefined;
};

export const A11y = {
	getTitle,
	getAriaLabel,
};
